import getLogger from "logger/index";
import { postgraphql, get, post, put } from "util/apiRequest";
import { getDynamicRoute } from "util/createProfileIdPath";
import config from "lib/config";

const { GATEWAY_URL } = config;
const log = getLogger("PROFILE_REQUEST");
//FAR Profile
export const FAR_PROFILE_REQUEST = "FAR_PROFILE_REQUEST";
export const FAR_PROFILE_SUCCESS = "FAR_PROFILE_SUCCESS";
export const FAR_PROFILE_FAILURE = "FAR_PROFILE_FAILURE";

//Profile
export const PROFILE_REQUEST = "PROFILE_REQUEST";
export const PROFILE_SUCCESS = "PROFILE_SUCCESS";
export const PROFILE_FAILURE = "PROFILE_FAILURE";

//Social Update
export const SOCIAL_UPDATE_REQUEST = "SOCIAL_UPDATE_REQUEST";
export const SOCIAL_UPDATE_SUCCESS = "SOCIAL_UPDATE_SUCCESS";
export const SOCIAL_UPDATE_FAILURE = "SOCIAL_UPDATE_FAILURE";
//Social Checkins
export const CHECKINS_REQUEST = "CHECKINS_REQUEST";
export const CHECKINS_SUCCESS = "CHECKINS_SUCCESS";
export const CHECKINS_FAILURE = "CHECKINS_FAILURE";

//Feedback
export const FEEDBACK_REQUEST = "FEEDBACK_REQUEST";
export const FEEDBACK_SUCCESS = "FEEDBACK_SUCCESS";
export const FEEDBACK_FAILURE = "FEEDBACK_FAILURE";

//RECOMMENDATION
export const RECOMMENDATION_REQUEST = "RECOMMENDATION_REQUEST";
export const RECOMMENDATION_SUCCESS = "RECOMMENDATION_SUCCESS";
export const RECOMMENDATION_FAILURE = "RECOMMENDATION_FAILURE";

//hestia
export const HESTIA_REQUEST = "HESTIA_REQUEST";
export const HESTIA_SUCCESS = "HESTIA_SUCCESS";
export const HESTIA_FAILURE = "HESTIA_FAILURE";

export const HESTIA_UPDATE_REQUEST = "HESTIA_UPDATE_REQUEST";
export const HESTIA_UPDATE_SUCCESS = "HESTIA_UPDATE_SUCCESS";
export const HESTIA_UPDATE_FAILURE = "HESTIA_UPDATE_FAILURE";

//Review Rating
export const REVIEW_RATING_REQUEST = "REVIEW_RATING_REQUEST";
export const REVIEW_RATING_SUCCESS = "REVIEW_RATING_SUCCESS";
export const REVIEW_RATING_FAILURE = "REVIEW_RATING_FAILURE";

//new recommendation
export const NEW_RECOMMENDATION_REQUEST = "NEW_RECOMMENDATION_REQUEST";
export const NEW_RECOMMENDATION_SUCCESS = "NEW_RECOMMENDATION_SUCCESS";
export const NEW_RECOMMENDATION_FAILURE = "NEW_RECOMMENDATION_FAILURE";

//Share Profile
export const SHARE_PROFILE_REQUEST = "SHARE_PROFILE_REQUEST";
export const SHARE_PROFILE_SUCCESS = "SHARE_PROFILE_SUCCESS";
export const SHARE_PROFILE_FAILURE = "SHARE_PROFILE_FAILURE";

export const VALIDATE_SPAM_REQUEST = "VALIDATE_SPAM_REQUEST";
export const VALIDATE_SPAM_SUCCESS = "VALIDATE_SPAM_SUCCESS";
export const VALIDATE_SPAM_FAILURE = "VALIDATE_SPAM_FAILURE";

export const CLICK_DETECTOR_AND_SCROLL = "CLICK_DETECTOR_AND_SCROLL";
export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";

export function farProfileRequest() {
  return {
    type: FAR_PROFILE_REQUEST,
    status: REQUESTING,
  };
}
export function clickDetectorAndScroll(clickDetectorData) {
  return {
    type: CLICK_DETECTOR_AND_SCROLL,
    clickDetectorData,
  };
}
export function farProfileSuccess(responseData, selectedType) {
  return {
    type: FAR_PROFILE_SUCCESS,
    status: SUCCESS,
    responseData,
    selectedType,
  };
}
export function farProfileFailure(error) {
  return {
    type: PROFILE_FAILURE,
    status: ERROR,
    error,
  };
}
export function profileRequest() {
  return {
    type: PROFILE_REQUEST,
    status: REQUESTING,
  };
}
export function profileSuccess(profileData) {
  return {
    type: PROFILE_SUCCESS,
    status: SUCCESS,
    profileData,
  };
}
export function profileFailure(error) {
  return {
    type: PROFILE_FAILURE,
    status: ERROR,
    error,
  };
}
export function socialUpdateRequest() {
  return {
    type: SOCIAL_UPDATE_REQUEST,
    status: REQUESTING,
  };
}
export function socialUpdateSuccess(socialUpdateData) {
  return {
    type: SOCIAL_UPDATE_SUCCESS,
    status: SUCCESS,
    socialUpdateData,
  };
}
export function socialUpdateFailure(error) {
  return {
    type: SOCIAL_UPDATE_FAILURE,
    status: ERROR,
    error,
  };
}
export function fetchCheckinsRequest() {
  return {
    type: CHECKINS_REQUEST,
    status: REQUESTING,
  };
}
export function fetchCheckinsSuccess(fetchCheckinsData) {
  return {
    type: CHECKINS_SUCCESS,
    status: SUCCESS,
    fetchCheckinsData,
  };
}
export function fetchCheckinsFailure(error) {
  return {
    type: CHECKINS_FAILURE,
    status: ERROR,
    error,
  };
}

export function feedbackRequest() {
  return {
    type: FEEDBACK_REQUEST,
    status: REQUESTING,
  };
}
export function feedbackSuccess(feedbackData) {
  return {
    type: FEEDBACK_SUCCESS,
    status: SUCCESS,
    feedbackData,
  };
}
export function feedbackFailure(error) {
  return {
    type: FEEDBACK_FAILURE,
    status: ERROR,
    error,
  };
}

export function recommendationRequest() {
  return {
    type: RECOMMENDATION_REQUEST,
    status: REQUESTING,
  };
}
export function recommendationSuccess(recommendationData) {
  return {
    type: RECOMMENDATION_SUCCESS,
    status: SUCCESS,
    recommendationData,
  };
}
export function recommendationFailure(error) {
  return {
    type: RECOMMENDATION_FAILURE,
    status: ERROR,
    error,
  };
}
export function hestiaRequest() {
  return {
    type: HESTIA_REQUEST,
    status: REQUESTING,
  };
}
export function hestiaSuccess(hestiaData) {
  return {
    type: HESTIA_SUCCESS,
    status: SUCCESS,
    hestiaData,
  };
}
export function hestiaFailure(error) {
  return {
    type: HESTIA_FAILURE,
    status: ERROR,
    error,
  };
}
export function hestiaUpdateRequest() {
  return {
    type: HESTIA_UPDATE_REQUEST,
    status: REQUESTING,
  };
}
export function hestiaUpdateSuccess(hestiaUpdatedData) {
  return {
    type: HESTIA_UPDATE_SUCCESS,
    status: SUCCESS,
    hestiaUpdatedData,
  };
}
export function hestiaUpdateFailure(error) {
  return {
    type: HESTIA_UPDATE_FAILURE,
    status: ERROR,
    error,
  };
}
export function reviewRatingRequest() {
  return {
    type: REVIEW_RATING_REQUEST,
    status: REQUESTING,
  };
}
export function reviewRatingSuccess(reviewRatingResponse) {
  return {
    type: REVIEW_RATING_SUCCESS,
    status: SUCCESS,
    reviewRatingResponse,
  };
}
export function reviewRatingFailure(error) {
  return {
    type: REVIEW_RATING_FAILURE,
    status: ERROR,
    error,
  };
}
export function newRecommendationRequest() {
  return {
    type: NEW_RECOMMENDATION_REQUEST,
    status: REQUESTING,
  };
}
export function newRecommendationSuccess(newRecommendationResponse) {
  sessionStorage.setItem("is_recomm_already_added", true);
  return {
    type: NEW_RECOMMENDATION_SUCCESS,
    status: SUCCESS,
    newRecommendationResponse,
  };
}
export function newRecommendationFailure(error) {
  sessionStorage.setItem("is_recomm_already_added", false);
  return {
    type: NEW_RECOMMENDATION_FAILURE,
    status: ERROR,
    error,
  };
}
export function shareProfileRequest() {
  return {
    type: SHARE_PROFILE_REQUEST,
    status: REQUESTING,
  };
}
export function shareProfileSuccess(shareProfileResponse) {
  return {
    type: SHARE_PROFILE_SUCCESS,
    status: SUCCESS,
    shareProfileResponse,
  };
}
export function shareProfileFailure(error) {
  return {
    type: SHARE_PROFILE_FAILURE,
    status: ERROR,
    error,
  };
}

export function validateSpamRequest() {
  return {
    type: VALIDATE_SPAM_REQUEST,
    status: REQUESTING,
  };
}
export function validateSpamSuccess(validateSpamResponse) {
  return {
    type: VALIDATE_SPAM_SUCCESS,
    status: SUCCESS,
    validateSpamResponse,
  };
}
export function validateSpamFailure(error) {
  return {
    type: VALIDATE_SPAM_FAILURE,
    status: ERROR,
    error,
  };
}

export function profile(advertiser_id, nrds_id) {
  return async (dispatch) => {
    dispatch(profileRequest());
    try {
      const url = `${GATEWAY_URL}/${getDynamicRoute()}/api/v3/profile`;
      const reviewbody = {
        advertiser_id,
        nrds_id,
      };

      const reviewresult = await postgraphql(url, reviewbody);

      const resultJson = reviewresult;

      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      return dispatch(profileSuccess(resultJson.data));
    } catch (e) {
      log.error(
        "Error while fetching PROFILE_API data - advertiser_id / nrds_id: " +
          advertiser_id +
          " / " +
          nrds_id,
        e,
      );
      dispatch(profileFailure(e.message));
    }
  };
}

export function farProfile(
  advertiser_id,
  type,
  nrds_id,
  langCode = "en",
  seoUserType,
  profileId,
  isLexAgentListRequired = false,
  isGoogleBot = false,
) {
  return async (dispatch) => {
    dispatch(farProfileRequest());
    try {
      const selectType = type.toLowerCase();
      const dynamicPath = getDynamicRoute();
      const result = await get(
        `${config.GATEWAY_URL}/${dynamicPath}/api/v3/farprofile?fulfillment_id=${advertiser_id}&selectType=${selectType}&nrds_id=${nrds_id}&langCode=${langCode}&seoUserType=${seoUserType}&profileId=${profileId}&isGoogleBot=${isGoogleBot}&isLexAgentListRequired=${isLexAgentListRequired}`,
      );

      const resultJson = result;

      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      return dispatch(farProfileSuccess(resultJson?.data, type));
    } catch (e) {
      const url = `fulfillment_id=${advertiser_id}&selectType=${type.toLowerCase()}&nrds_id=${nrds_id}&langCode=${langCode}&seoUserType=${seoUserType}&profileId=${profileId}`;
      log.error("Error while fetching BACKEND_PROFILE_API data - Request URL: " + url, e);
      dispatch(farProfileFailure(e.message));
    }
  };
}
export function socialUpdates(social_connections) {
  return async (dispatch) => {
    dispatch(socialUpdateRequest());
    try {
      const socialUpdatesBody = {
        social_connections,
      };

      const result = await post(
        `${config.GATEWAY_URL}/${getDynamicRoute()}/api/v3/socialupdates`,
        socialUpdatesBody,
        15000,
      );

      const resultJson = result;
      const socialUpdateData = resultJson && resultJson.data;

      // var resultArray = Object.keys(socialUpdateData).map((key) => socialUpdateData[key]);
      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      return dispatch(socialUpdateSuccess(socialUpdateData));
    } catch (e) {
      log.error(
        "Error while fetching socialUpdates data for the fulfillment_id : " +
          social_connections?.fulfillment_id,
        e,
      );
      dispatch(socialUpdateFailure(e.message));
    }
  };
}
export function fetchCheckins(advertiser_id, nrds_id) {
  return async (dispatch) => {
    dispatch(fetchCheckinsRequest());
    try {
      const result = await get(
        `${
          config.GATEWAY_URL
        }/${getDynamicRoute()}/api/v3/fetchcheckins?fulfillment_id=${advertiser_id}&nrds_id=${nrds_id}`,
        8000,
      );

      const resultJson = result && result.data && result.data[0];

      return dispatch(fetchCheckinsSuccess(resultJson));
    } catch (e) {
      log.error(
        "Error while fetching FETCH_CHECKIN_API data - advertiser_id / nrds_id: " +
          advertiser_id +
          " / " +
          nrds_id,
        e,
      );
      dispatch(fetchCheckinsFailure(e.message));
    }
  };
}

export function feedback(advertiser_id) {
  return async (dispatch) => {
    dispatch(feedbackRequest());
    try {
      const url = `${GATEWAY_URL}/${getDynamicRoute()}/api/v3/review`;
      const reviewbody = {
        advertiser_id,
      };

      const reviewresult = await postgraphql(url, reviewbody);

      const resultJson = reviewresult;

      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      return dispatch(feedbackSuccess(resultJson.data));
    } catch (e) {
      log.error(
        "Error while fetching FEEDBACK_REVIEW_API data - advertiser_id: " + advertiser_id,
        e,
      );
      dispatch(feedbackFailure(e.message));
    }
  };
}

export function recommendation(advertiser_id) {
  return async (dispatch) => {
    dispatch(recommendationRequest());
    try {
      const url = `${GATEWAY_URL}/${getDynamicRoute()}/api/v3/recommendation`;
      const recommendationbody = {
        advertiser_id,
      };

      const recommresult = await postgraphql(url, recommendationbody);

      const resultJson = recommresult;

      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      return dispatch(recommendationSuccess(resultJson.data));
    } catch (e) {
      log.error(
        "Error while fetching RECOMMENDATION_API data  - advertiser_id: " + advertiser_id,
        e,
      );
      dispatch(recommendationFailure(e.message));
    }
  };
}

export function hestiaInformation(
  fulfillment_ids,
  agents = [],
  page = 1,
  type = "all",
  callerNote,
) {
  return async (dispatch) => {
    if (page === 1) {
      dispatch(hestiaRequest());
    } else {
      dispatch(hestiaUpdateRequest());
    }
    try {
      const url = `${config.GATEWAY_URL}/${getDynamicRoute()}/api/v3/listings`;
      const body = {
        fulfillment_ids,
        agents,
        page,
        type,
      };

      const listings = await post(url, body, 10000);
      let result = null;
      if (listings && listings.data && listings.data.data) {
        result = listings.data.data;
      } else {
        throw listings && listings.data ? listings.data : "No response from Hestia";
      }

      if (page === 1) {
        return dispatch(hestiaSuccess(result));
      } else {
        return dispatch(hestiaUpdateSuccess(result));
      }
    } catch (error) {
      const body = {
        fulfillment_ids,
        agents,
        page,
        type,
        callerNote,
      };
      log.error("Error while fetching HESTIA_API data - Request : " + JSON.stringify(body), error);
      if (page === 1) {
        dispatch(hestiaFailure(error.message));
      } else {
        dispatch(hestiaUpdateFailure(error.message));
      }
    }
  };
}

export function reviewRating(reviewParams) {
  return async (dispatch) => {
    dispatch(reviewRatingRequest());
    try {
      const url = `${GATEWAY_URL}/${getDynamicRoute()}/api/v3/review`;
      const reviewBody = reviewParams;

      const reviewResult = await put(url, reviewBody);
      if (reviewResult.error) {
        throw new Error(reviewResult.message);
      }
      return dispatch(reviewRatingSuccess(reviewResult));
    } catch (error) {
      log.error(
        "Error while submitting rating and review information for Email / Advertiser_id : " +
          reviewParams?.email +
          " / " +
          reviewParams?.advertiser_id,
        error,
      );
      dispatch(reviewRatingFailure(error.message));
    }
  };
}

export function newRecommendation(recommendationParams) {
  return async (dispatch) => {
    dispatch(newRecommendationRequest());

    try {
      const url = `${GATEWAY_URL}/${getDynamicRoute()}/api/v3/new_recommendation`;
      const recommendationBody = {
        recommendationParams,
      };
      const recommendationResult = await post(url, recommendationBody);
      if (recommendationResult.error) {
        throw new Error(recommendationResult.message);
      }
      return dispatch(newRecommendationSuccess(recommendationResult));
    } catch (error) {
      log.error(
        "Error while submitting Recommendation for Email / Advertiser_id : " +
          recommendationParams?.email +
          " / " +
          recommendationParams?.advertiser_id,
        error,
      );
      dispatch(newRecommendationFailure(error.message));
    }
  };
}
export function share(shareParams) {
  return async (dispatch) => {
    dispatch(shareProfileRequest());
    try {
      const url = `${GATEWAY_URL}/${getDynamicRoute()}/api/v3/share`;
      const shareBody = {
        shareParams,
      };
      const shareResult = await post(url, shareBody);
      if (shareResult.data && shareResult.data.success) {
        return dispatch(shareProfileSuccess(SUCCESS));
      }
      throw new Error(shareResult.data);
    } catch (error) {
      log.error(
        "Error while sharing the Profile : From : " +
          shareParams?.yourEmail +
          "; To :" +
          shareParams?.email +
          ";",
        error,
      );
      dispatch(shareProfileFailure(error.message));
    }
  };
}

export function validateSpam(email, name, comment) {
  return async (dispatch) => {
    dispatch(validateSpamRequest());
    try {
      const url = `${GATEWAY_URL}/${getDynamicRoute()}/api/v3/validateSpam`;
      const validateBody = {
        email,
        name,
        comment,
      };
      const recommendationResult = await post(url, validateBody);
      if (recommendationResult.error) {
        throw new Error(recommendationResult.message);
      }
      return dispatch(validateSpamSuccess(recommendationResult));
    } catch (error) {
      const validateBody = {
        email,
        name,
        comment,
      };
      log.error("Error while validateSpam Request : " + JSON.stringify(validateBody), error);
      dispatch(validateSpamFailure(error.message));
    }
  };
}
